import { colorTokens } from '../../foundations/color-tokens.ts'

export const chipVariants = ['neutral', 'informal', 'success', 'warning', 'danger', 'brand'] as const

export type ChipVariant = (typeof chipVariants)[number]

type Colors = { backgroundColor: string; textColor: string; iconColor: string }

export const colorsPerVariant: {
  [variant in ChipVariant]: { light: Colors; dark: Colors }
} = {
  neutral: {
    light: {
      backgroundColor: colorTokens['color-bg-neutral-inverse'],
      textColor: colorTokens['color-text-base-main'],
      iconColor: colorTokens['color-fg-base'],
    },
    dark: {
      backgroundColor: colorTokens['color-bg-neutral'],
      textColor: colorTokens['color-text-base-inverse'],
      iconColor: colorTokens['color-fg-base-inverse'],
    },
  },
  informal: {
    light: {
      backgroundColor: colorTokens['color-bg-info-inverse'],
      textColor: colorTokens['color-text-info-primary'],
      iconColor: colorTokens['color-fg-info'],
    },
    dark: {
      backgroundColor: colorTokens['color-bg-info-primary'],
      textColor: colorTokens['color-text-base-inverse'],
      iconColor: colorTokens['color-fg-info-primary'],
    },
  },
  success: {
    light: {
      backgroundColor: colorTokens['color-bg-success-inverse'],
      textColor: colorTokens['color-text-success-primary'],
      iconColor: colorTokens['color-fg-success'],
    },
    dark: {
      backgroundColor: colorTokens['color-bg-success-primary'],
      textColor: colorTokens['color-text-base-inverse'],
      iconColor: colorTokens['color-fg-success-primary'],
    },
  },
  warning: {
    light: {
      backgroundColor: colorTokens['color-bg-warning-inverse'],
      textColor: colorTokens['color-text-warning-primary'],
      iconColor: colorTokens['color-fg-warning'],
    },
    dark: {
      backgroundColor: colorTokens['color-bg-warning-primary'],
      textColor: colorTokens['color-text-base-inverse'],
      iconColor: colorTokens['color-fg-warning-primary'],
    },
  },
  danger: {
    light: {
      backgroundColor: colorTokens['color-bg-danger-inverse'],
      textColor: colorTokens['color-text-danger-primary'],
      iconColor: colorTokens['color-fg-danger'],
    },
    dark: {
      backgroundColor: colorTokens['color-bg-danger-primary'],
      textColor: colorTokens['color-text-base-inverse'],
      iconColor: colorTokens['color-fg-danger-primary'],
    },
  },
  brand: {
    light: {
      backgroundColor: colorTokens['color-bg-brand-light'],
      textColor: colorTokens['color-text-base-main'],
      iconColor: colorTokens['color-fg-base'],
    },
    dark: {
      backgroundColor: colorTokens['color-bg-brand-dark'],
      textColor: colorTokens['color-text-base-inverse'],
      iconColor: colorTokens['color-fg-base-inverse'],
    },
  },
}

export function getChipResolvedTextColor(params: {
  variant?: ChipVariant | undefined
  dark?: boolean | undefined
  textColor?: string | undefined
}): string {
  const { variant = 'neutral', dark = false, textColor } = params
  if (textColor !== undefined && textColor !== '') {
    return textColor
  }
  return colorsPerVariant[variant][dark ? 'dark' : 'light'].textColor
}
